var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"point",staticClass:"point",style:(`left:${_vm.moveLeft}px;top:${_vm.moveTop}px;`),on:{"touchstart":_vm.dragStart,"touchend":_vm.dragEnd,"touchmove":function($event){$event.preventDefault();return _vm.dragMove.apply(null, arguments)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }